import { FormattedMessage } from "react-intl";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";

import { SubHeading, WelcomeBackHeading } from "../components";

import { ServiceCollectionLogo } from "./components/service-collection-logo";

export const ExistingUser = () => (
    <SignupBackgroundLayout
        ProductLogo={<ServiceCollectionLogo />}
        theme="yellow"
    >
        <WelcomeBackHeading />
        <SubHeading>
            <FormattedMessage
                id="signup.serviceCollection.subHeading"
                defaultMessage="It’s free for up to 3 agents - no credit card needed."
            />
        </SubHeading>
        <SiteActivation />
    </SignupBackgroundLayout>
);
